module.exports = __webpack_public_path__ + "static/img/14000200.11d981bc.png";